/** Stores **/
export const RESTRICTED_ACTIONS = {
  admin: {
    company_information: ["create", "delete"],
    esg_dashboard: ["create", "update", "delete"],
    onboard_setup: ["delete"],
  },
  user: {
    company_information: ["create", "delete", "update"],
    esg_dashboard: ["create", "update", "delete"],
    onboard_setup: ["delete"],
    target_setting: ["create", "update", "delete"],
    master_data: ["create", "update", "delete"],
    reporting_boundary: ["create", "update", "delete"],
    organization: ["create", "update", "delete"],
    custom_framework: ["create", "update", "delete"],
  },
};

export const ADMIN_GROUP = ["system_admin", "business_unit"];
export const BANK_GROUP = ["bank_admin", "sme_user"];

export const SYSTEM_ROLES = [
  "system_admin",
  "business_unit",
  "super_admin",
  "reseller",
  "solution_provider",
  "bank_admin",
  "sme_user",
];

export const EXCLUDED_PERMISSIONS_IDS = ["activity_log", "user_profile"]; // default view & not include in permissions table
